const C = require("../constants");
const initial_data = {
    open: false,
    recipe: {
        id:null,
        name: ''
    }
};

function RecipeDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.RECIPE_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default RecipeDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/RecipeDialogReducer.js